<template>
    <div class="count-picker">
        <button class="count-picker__btn" @click="handleChange(-1)" :disabled="count === 1">-</button>
        <span class="count-picker__value">{{ count }}</span>
        <button class="count-picker__btn" @click="handleChange(1)">+</button>
    </div>
</template>
<script src="./countPicker.js"></script>
<style src="./countPicker.scss" lang="scss" scoped />
